import React, { useEffect, useState } from "react";

import { getInitialLayoutState } from "./usePageLayoutState";

import { LeftPanelContainer } from "./LeftPanel.styles";

interface LeftPanelProps {
  id?: string;
  children: React.ReactNode;
}

/**
 * Left panel component for icon bar or quick navigation.
 * Fixed positioned with width from localStorage (default 77px).
 * Sets the --leftPanelWidth CSS custom property.
 */
const LeftPanel: React.FC<LeftPanelProps> = ({ id, children }) => {
  const [width] = useState(() => getInitialLayoutState().gridState.leftPanelWidth);

  useEffect(() => {
    // Set CSS custom property for left panel width
    document.documentElement.style.setProperty("--leftPanelWidth", `${width}px`);

    return () => {
      // Clean up on unmount
      document.documentElement.style.removeProperty("--leftPanelWidth");
    };
  }, [width]);

  return (
    <LeftPanelContainer id={id} $width={width}>
      {children}
    </LeftPanelContainer>
  );
};

export default LeftPanel;
